//import { baseUrl } from './env'
import vm from '../main';
import { Toast } from 'vant';
import { getStore, removeStore } from './utils';

const logout = () => {
    removeStore('Token');
    removeStore('UserName');

    vm.$router.push('/login');
  return {
    Message: window.lg.common._logout
  };
};

let loadCount = 0;
const load = {
  open: () => {
    loadCount++;
    Toast.loading({
      message: 'loading...',
      forbidClick: false, // 不锁定 body 滚动
      loadingType: 'spinner'
    });
  },
  close: () => {
    loadCount--;
    if (loadCount < 1) {
      loadCount = 0;
      Toast.clear();
    }
  }
};

export default async (url = '', data = {}, isLoad = false, type = 'GET', method = 'fetch') => {
  type = type.toUpperCase();
  //url = baseUrl + url;

  let dataStr = ''; //数据拼接字符串
  Object.keys(data).forEach(key => {
    dataStr += key + '=' + data[key] + '&';
  });

  if (type == 'GET') {
    if (dataStr !== '') {
      url = url + '?' + dataStr;
    } else {
      url += '?';
    }

    url += 'v=' + new Date().getTime();
  }

  dataStr = dataStr.replace(/&$/, '');

  if (isLoad) {
    load.open();
  }

  if (window.fetch && method == 'fetch') {
    let requestConfig = {
      credentials: 'include',
      method: type,
      headers: {
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        Authorization: url.indexOf('AgentBayo')==-1 ? getStore('Token') : getStore('AgentToken'),
        cuid: getStore('cuid')||'',
        afid: getStore('afid')||'',
        event_name: getStore('event_name')||'',
        'lang': window.language,
      },
      mode: 'cors',
      cache: 'force-cache'
    };

    if (type == 'POST') {
      Object.defineProperty(requestConfig, 'body', {
        value: JSON.stringify(data),
        writable: true,
        enumerable: true,
        configurable: true
      });
    }

    try {
      const response = await fetch(url, requestConfig);
      if (response.status == 200) {
        const responseJson = await response.json();
        if (responseJson.Message == 'LogoutAlready' || responseJson.Message && responseJson.Message.indexOf('Unauthorized') != -1 || responseJson.Message && responseJson.Message.indexOf('401') != -1 || responseJson.Message == 'TokenInvalid') {
          responseJson.Message = window.lg.common._logout;
          return logout();
        }

        return responseJson;
      } else if (response.status == 401) {
        return logout();
      } else {
        return {
          Message: window.lg.common._notinternet
        };
      }
    } catch (err) {
      return {
        Message: err
      };
    } finally {
      if (isLoad) {
        load.close();
      }
    }
  } else {
    return new Promise((resolve) => {
      let requestObj;
      if (window.XMLHttpRequest) {
        requestObj = new XMLHttpRequest();
      } else {
        requestObj = new window.ActiveXObject('Microsoft.XMLHTTP');
      }

      // let sendData = '';
      // if (type == 'POST') {
      // 	sendData = JSON.stringify(data);
      // }

      // if (!process.env.NODE_ENV == 'production') {
      // 	requestObj.withCredentials = true //跨域发送cookies声明
      // }
      try {
        requestObj.open(type, url, true);
        requestObj.setRequestHeader('Content-type', 'application/json');
        requestObj.setRequestHeader('Authorization', url.indexOf('AgentBayo')==-1 ? getStore('Token') : getStore('AgentToken'));
        requestObj.setRequestHeader("lang", window.language);
        requestObj.setRequestHeader("cuid", getStore('cuid')||'');
        requestObj.setRequestHeader("afid", getStore('afid')||'');
        requestObj.setRequestHeader("event_name", getStore('event_name')||'');

        if (type == 'POST') {
          requestObj.send(JSON.stringify(data));
        } else {
          requestObj.send();
        }

        requestObj.onreadystatechange = () => {
          if (requestObj.readyState == 4) {
            load.close();

            if (requestObj.status == 200) {
              let obj = requestObj.responseText;
              if (typeof obj !== 'object') {
                obj = JSON.parse(obj);
              }

              if (obj.Message == 'LogoutAlready' || obj.Message && obj.Message.indexOf('Unauthorized') != -1||obj.Message=='TokenInvalid') {
                obj = logout(url);
              }

              resolve(obj);
            } else if (requestObj.status == 401) {
              resolve(logout(url));
            } else {
              resolve({
                Message: window.lg.common._notinternet
              });
            }
          }
        };
      } catch (err) {
        resolve({
          Message: err
        });
      } finally {
        if (isLoad) {
          load.close();
        }
      }
    });
  }
};
